// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2czSr","label":"Labeled_label__1UorJ","divider":"Labeled_divider__2cAxT"};